type Status = "Active" | "InActive" | "Pending";

const STYLES: Record<Status, { backgroundColor: string; color: string }> = {
  Active:   { backgroundColor: "#aaece5", color: "#296d67" },
  InActive: { backgroundColor: "#e9e9df", color: "#42484a" },
  Pending:  { backgroundColor: "#e9e9df", color: "#42484a" },
};

const StatusPill = ({ status }: { status: Status }) => (
  <span
    className="px-[10px] py-[2px] rounded-xl text-[10px] font-medium"
    style={STYLES[status]}
  >
    {status}
  </span>
);

export default StatusPill;
